<template>
  <div v-if="form.gateway != undefined">

    <title-row
      :title="page.title"
      :breadcrumb-items="[
        { text: 'Átjárók', to: { name: 'GatewayList' } },
        page.breadcrumbItem,
      ]">
      <template #buttons>
        <title-row-button v-if="hasRight('KEY_WRITE')" @click="save" title="Mentés">
          <v-icon dark>mdi-content-save</v-icon>
          Mentés
        </title-row-button>
      </template>
    </title-row>

    <v-row>
      <v-col :cols="12" :lg="6">
        <v-card>
          <v-card-title>Átjáró adatok</v-card-title>
          <v-card-text>
            <v-text-field
              label="Megnevezés"
              :error-messages="errors.name"
              v-model="form.gateway.name"
              filled />
            <v-select
              label="Épület"
              :error-messages="errors.building_id"
              v-model="form.gateway.building_id"
              :items="buildings"
              item-text="label"
              item-value="value"
              filled />
            <v-text-field
              label="Folyamat név"
              :error-messages="errors.process_name"
              v-model="form.gateway.process_name"
              filled />
            <v-masked-text-field
              label="Cím"
              :error-messages="errors.address"
              v-model="form.gateway.address"
              :mask="$config.inputMasks.gatewayAdddress"
              filled />
            <v-masked-text-field
              label="Port"
              :error-messages="errors.port"
              v-model="form.gateway.port"
              filled
              :mask="$config.inputMasks.integerNumber" />
            <v-textarea
              label="Megjegyzés"
              :error-messages="errors.comment"
              v-model="form.gateway.comment"
              filled />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      form: {
      },
      buildings: [],
      errors: {},
      loading: false
    };
  },

  mounted() {
    this.fetchGateway();
  },

  methods: {
    async fetchGateway() {
      this.loading = true;
      try {
        const response = await this.$http.get(`gateways/details/${this.$route.params.id || 0}`);
        this.buildings = [{ value: 0, label: '- válassz -' }, ...response.buildings];
        this.$set(this.form, 'gateway', response.gateway);

      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async save() {
      const _this = this;
      this.loading = true;
      this.errors = {};

      try {
        const response = await this.$http.post('gateways/save', this.form.gateway);

        this.loading = false;

        if (Object.keys(response.errors).length) {
          return this.errors = response.errors;
        }
        this.$dialog.notify.success('Sikeres mentés');
        this.$router.replace({ name: 'GatewayList' });

      } catch (e) {
        this.$dialog.notify.error(e);
      }
    },
  },
  computed: {
    page() {
      switch (this.$route.name) {
        case 'NewGateway':
          return {
            isNew: true,
            title: 'Új átjáró',
            breadcrumbItem: {
              text: 'Új átjáró',
              disabled: true,
            },
          };
        case 'GatewayEditor':
          return {
            isNew: false,
            title: `${this.form.gateway.name ?? 'Betöltés...'}`,
            breadcrumbItem: {
              text: this.form.gateway.name,
              disabled: true,
            },
          };
        default:
          return {};
      }
    },
  },
};
</script>
